export default __webpack_public_path__ + "static/anxiety-807e2f240615ad05035c2e7ff46f8b54.webp";